import { Entity, FieldValue } from '@msdk/definitions'
import React from 'react'

interface Props {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any*/
  value: FieldValue<any> | null
  row?: Entity
}

const getFilters = (props: Props) => {
  const filters = props.row?.fields['FILTER_SERIALIZATION'] ? props.row.fields['FILTER_SERIALIZATION'].value : ''
  const contextId = props.row?.fields['CONTEXT_ID'] ? props.row.fields['CONTEXT_ID'].value : ''

  if ((!filters || filters == '') && contextId == '') return ''
  let strFilters = ''
  if (filters && filters != '') {
    const filtersArray = JSON.parse(filters).$values
    if (filtersArray) {
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any*/
      filtersArray.forEach((value: { fieldDescription: any; valueDescription: any }) => {
        if (strFilters != '') strFilters += ', '
        strFilters += `${value.fieldDescription}: ${value.valueDescription}`
      })
    }
  } else if (contextId != '') {
    strFilters = `ID: ${contextId}`
  }

  return strFilters
}

export function ViewFiltersApplied(props: Props) {
  return <span>{getFilters(props)}</span>
}
